<script lang="ts">
    import Manager from "../application/models/Manager.ts";

    export let manager : Manager;
</script>

{#each Array(56) as _,i}
    <div class="columns">
        <div class="column timeText">
            {manager.dateManager.calculateTimeFromBlockNumber(i+28)}
        </div>
    </div>
{/each}

<style>
    .timeText{
        font-size: 10px;
        padding: 0 0 0 15px;
        margin: 0!important;
        line-height: 25px;
    }

    .column{
        width: 50px;
        min-height: 25px;
        max-height: 25px;
        border-bottom: 1px solid rgba(243, 243, 243, 0.25);
        border-left: 1px solid rgba(243, 243, 243, 0.25);
    }
</style>